import { BarsOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import type { CSSProperties } from 'react'

// Sits on the left end of the sticky header (64px high, button 40px): `responsive.css` keeps that
// corner of `HeaderBar` empty at the same width the drawer menu starts.
const buttonStyle: CSSProperties = {
  borderStartStartRadius: 0,
  borderEndStartRadius: 0,
  position: 'fixed',
  top: 12,
  zIndex: 999,
}

/**
 * Opens the side menu drawer. Rendered by the side menu only while `useUsesDrawerMenu()` is true.
 *
 * It used to float under the header (top 64px), where it covered the page title and breadcrumb.
 */
export function MenuDrawerButton({ onClick }: { onClick: () => void }): React.JSX.Element {
  return (
    <Button
      data-testid="sider-mobile-open-btn"
      style={buttonStyle}
      size="large"
      onClick={onClick}
      icon={<BarsOutlined />}
    />
  )
}
